// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/chevron-right.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'chevron-right',
  version: 'outline',
  paths: [
    {
      d: 'm8.25 4.5 7.5 7.5-7.5 7.5',
    },
  ],
}
